// Only the phone apps act as Remote controllers.
export async function createRemoteWorkTask() { return null; }
export async function withRemoteWorkTask(_task, send) { return send({}); }
